window.addEventListener('load', function () {
    'use strict';

    if (!document.querySelector('.pd-hero')) return;

    // Hero reveal timeline
    var heroTl = gsap.timeline();

    heroTl.fromTo('.pd-hero__breadcrumb',
        { y: 15, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.6, ease: 'power3.out' }
    )
    .fromTo('.pd-hero__tag',
        { y: 15, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.6, ease: 'power3.out' },
        '-=0.3'
    )
    .fromTo('.pd-hero__location',
        { y: 15, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.6, ease: 'power3.out' },
        '-=0.4'
    )
    .fromTo('.pd-hero__title-word',
        { y: 80, opacity: 0 },
        { y: 0, opacity: 1, duration: 1, stagger: 0.12, ease: 'power3.out' },
        '-=0.3'
    )
    .fromTo('.pd-hero__subtitle',
        { y: 20, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.8, ease: 'power3.out' },
        '-=0.5'
    );

    if (document.querySelector('.pd-hero__actions')) {
        heroTl.fromTo('.pd-hero__actions',
            { y: 20, opacity: 0 },
            { y: 0, opacity: 1, duration: 0.6, ease: 'power3.out' },
            '-=0.3'
        );
    }

    heroTl.fromTo('.pd-hero__stat',
        { y: 20, opacity: 0 },
        { y: 0, opacity: 1, stagger: 0.1, duration: 0.6, ease: 'power3.out' },
        '-=0.4'
    )
    .fromTo('.pd-hero__scroll',
        { opacity: 0 },
        { opacity: 1, duration: 0.6 },
        '-=0.3'
    );

    // Hero bg parallax
    var heroBgImg = document.querySelector('.pd-hero__bg img');
    if (heroBgImg) {
        gsap.to(heroBgImg, {
            yPercent: 20,
            ease: 'none',
            scrollTrigger: {
                trigger: '.pd-hero',
                start: 'top top',
                end: 'bottom top',
                scrub: true
            }
        });
    }

    // Gallery parallax + fade
    gsap.utils.toArray('.pd-gallery__item').forEach(function (item) {
        var img = item.querySelector('img');
        if (!img) return;

        gsap.fromTo(img,
            { scale: 1.15, opacity: 0 },
            {
                scale: 1, opacity: 1,
                duration: 1.4,
                ease: 'power3.out',
                scrollTrigger: {
                    trigger: item,
                    start: 'top 85%',
                    toggleActions: 'play none none none'
                }
            }
        );

        gsap.to(img, {
            yPercent: -8,
            ease: 'none',
            scrollTrigger: {
                trigger: item,
                start: 'top bottom',
                end: 'bottom top',
                scrub: true
            }
        });
    });

    // Features cards stagger
    gsap.utils.toArray('.pd-features__card').forEach(function (card, i) {
        gsap.fromTo(card,
            { y: 50, opacity: 0 },
            {
                y: 0, opacity: 1,
                duration: 0.8,
                delay: i * 0.15,
                ease: 'power3.out',
                scrollTrigger: {
                    trigger: card,
                    start: 'top 85%',
                    toggleActions: 'play none none none'
                }
            }
        );
    });

    // Location bg parallax
    var locBg = document.querySelector('.pd-location__bg img');
    if (locBg) {
        gsap.to(locBg, {
            yPercent: 15,
            ease: 'none',
            scrollTrigger: {
                trigger: '.pd-location',
                start: 'top bottom',
                end: 'bottom top',
                scrub: true
            }
        });
    }

    // Location list items stagger
    gsap.utils.toArray('.pd-location__list-item').forEach(function (item, i) {
        gsap.fromTo(item,
            { x: 30, opacity: 0 },
            {
                x: 0, opacity: 1,
                duration: 0.7,
                delay: i * 0.1,
                ease: 'power3.out',
                scrollTrigger: {
                    trigger: item,
                    start: 'top 90%',
                    toggleActions: 'play none none none'
                }
            }
        );
    });

    // Disposition floors stagger
    gsap.utils.toArray('.pd-disposition__floor').forEach(function (floor, i) {
        gsap.fromTo(floor,
            { y: 40, opacity: 0 },
            {
                y: 0, opacity: 1,
                duration: 0.8,
                delay: i * 0.15,
                ease: 'power3.out',
                scrollTrigger: {
                    trigger: floor,
                    start: 'top 85%',
                    toggleActions: 'play none none none'
                }
            }
        );
    });

    // CTA inner reveal
    var pdCtaInner = document.querySelector('.pd-cta__inner');
    if (pdCtaInner) {
        gsap.fromTo(pdCtaInner,
            { y: 50, opacity: 0 },
            {
                y: 0, opacity: 1,
                duration: 1,
                ease: 'power3.out',
                scrollTrigger: {
                    trigger: pdCtaInner,
                    start: 'top 80%',
                    toggleActions: 'play none none none'
                }
            }
        );
    }

    // CTA bg parallax
    var pdCtaBg = document.querySelector('.pd-cta__bg img');
    if (pdCtaBg) {
        gsap.to(pdCtaBg, {
            yPercent: 10,
            ease: 'none',
            scrollTrigger: {
                trigger: '.pd-cta',
                start: 'top bottom',
                end: 'bottom top',
                scrub: true
            }
        });
    }

    // ─── pd-story ───
    var storyImg = document.querySelector('.pd-story__image img');
    if (storyImg) {
        gsap.fromTo(storyImg,
            { scale: 1.12, opacity: 0 },
            {
                scale: 1, opacity: 1,
                duration: 1.4,
                ease: 'power3.out',
                scrollTrigger: {
                    trigger: '.pd-story__image',
                    start: 'top 85%',
                    toggleActions: 'play none none none'
                }
            }
        );
        gsap.to(storyImg, {
            yPercent: -10,
            ease: 'none',
            scrollTrigger: {
                trigger: '.pd-story__image',
                start: 'top bottom',
                end: 'bottom top',
                scrub: true
            }
        });
    }

    // ─── pd-process ───
    gsap.utils.toArray('.pd-process__phase').forEach(function (phase, i) {
        gsap.fromTo(phase,
            { y: 40, opacity: 0 },
            {
                y: 0, opacity: 1,
                duration: 0.8,
                delay: i * 0.12,
                ease: 'power3.out',
                scrollTrigger: {
                    trigger: phase,
                    start: 'top 85%',
                    toggleActions: 'play none none none'
                }
            }
        );
    });

    // ─── pd-worth ───
    gsap.utils.toArray('.pd-worth__highlight').forEach(function (hl, i) {
        gsap.fromTo(hl,
            { y: 30, opacity: 0 },
            {
                y: 0, opacity: 1,
                duration: 0.7,
                delay: i * 0.12,
                ease: 'power3.out',
                scrollTrigger: {
                    trigger: hl,
                    start: 'top 88%',
                    toggleActions: 'play none none none'
                }
            }
        );
    });

    // ─── pd-highlight ───
    gsap.utils.toArray('.pd-highlight__image').forEach(function (wrap) {
        var img = wrap.querySelector('img');
        if (!img) return;

        gsap.fromTo(img,
            { scale: 1.1, opacity: 0 },
            {
                scale: 1, opacity: 1,
                duration: 1.2,
                ease: 'power3.out',
                scrollTrigger: {
                    trigger: wrap,
                    start: 'top 80%',
                    toggleActions: 'play none none none'
                }
            }
        );

        gsap.to(img, {
            yPercent: -8,
            ease: 'none',
            scrollTrigger: {
                trigger: wrap,
                start: 'top bottom',
                end: 'bottom top',
                scrub: true
            }
        });
    });

    // ─── pd-vision ───
    var visionBg = document.querySelector('.pd-vision__bg img');
    if (visionBg) {
        gsap.to(visionBg, {
            yPercent: 15,
            ease: 'none',
            scrollTrigger: {
                trigger: '.pd-vision',
                start: 'top bottom',
                end: 'bottom top',
                scrub: true
            }
        });
    }

    // Vision column divider grow (vertical line between columns)
    var visionColumns = document.querySelector('.pd-vision__columns');
    if (visionColumns) {
        gsap.fromTo(visionColumns,
            { '--divider-scale': 0 },
            {
                '--divider-scale': 1,
                duration: 1,
                ease: 'power2.out',
                scrollTrigger: {
                    trigger: visionColumns,
                    start: 'top 80%',
                    toggleActions: 'play none none none'
                }
            }
        );
    }
});
